(() => {
  const name = 'homeTrial';

  App.common = App.common || {};

  App.common[name] = (() => {
    let $quickcartWrapper;
    let $homeTrialCartWrapper;
    let $homeTrialForm;
    let $homeTrialQuickCartCTA;
    let $homeTrialQuickCartEmptyCTA;
    let $homeTrialPlaceOrderButton;
    let $homeTrialFormInputs;
    let $homeTrialFormErrorMessage;
    const { isSessionStorageSupported } = App.global;

    // eslint-disable-next-line consistent-return
    const getHomeTrialProducts = async () => {
      try {
        return $.ajax({ url: '/home-trial' });
      } catch (err) {
        App.sendErrorToRaygun(err);
      }
    };

    const cartMaxCountExceededPopup = () => {
      App.ui.popup(texts('maxProductsInCartExceeded@homeTrial'), {
        className: 'dialog-window',
        alert: { ok: { text: texts('confirm@paymentPop') } },
      });
    };

    const errorPopup = () => {
      App.ui.popup(texts('removeOrderError@product'), {
        className: 'dialog-window',
        alert: { ok: { text: texts('confirm@paymentPop') } },
      });
    };

    const addHomeTrialPackToCart = async (e, { includedProducts }) => {
      const productIds = includedProducts.map(({ id }) => id);
      try {
        const { status, reason } = await $.ajax({
          url: '/home-trial/add-pack',
          data: { productIds: JSON.stringify(productIds) },
          type: 'POST',
        });

        switch (status) {
          case 'ok': {
            TrackApp.trackInteraction(
              'home trial',
              'Cart add home trial',
              productIds.join(),
            );
            if (isSessionStorageSupported()) {
              window.sessionStorage.setItem('homeTrialPackAdded', 'true');
            }
            App.eventBus.trigger('quickcart:row-added', { productType: 'home-trial' });
            window.location.href = App.global.getRedirectUrl('/home-trial/cart');
            break;
          }
          case 'error': {
            if (reason === 'cart-max-count-exceeded') {
              cartMaxCountExceededPopup();
              App.global.sendErrorLog('Home Trial - cart max count exceeded');
            }
            break;
          }
          default: {
            break;
          }
        }
      } catch (err) {
        App.sendErrorToRaygun(err);
      }
    };

    const isDifferentHomeTrialSizesAdded = (homeTrialCartItems) => {
      // Skip info message about different sizes for pre-packs
      if (isSessionStorageSupported() && window.sessionStorage.getItem('homeTrialPackAdded')) {
        return false;
      }

      let isDifferentSizesAdded = false;

      if (homeTrialCartItems.length > 1) {
        for (let i = 0; i < homeTrialCartItems.length - 1; i += 1) {
          const currentSizeLabel = homeTrialCartItems[i].productItem.frameSize;
          const nextSizeLabel = homeTrialCartItems[i + 1].productItem.frameSize;

          if (currentSizeLabel !== nextSizeLabel) {
            isDifferentSizesAdded = true;
            break;
          }
        }
      }

      return isDifferentSizesAdded;
    };

    const addProductToHomeTrialCart = async (e, { productId }) => {
      try {
        const { status, reason } = await $.ajax({
          url: '/home-trial/add',
          data: { productId },
          type: 'POST',
        });

        switch (status) {
          case 'ok': {
            App.eventBus.trigger('quickcart:row-added', { productType: 'home-trial' });
            App.eventBus.trigger('quickcart:open');
            TrackApp.trackInteraction('home trial', 'Cart add home trial', `${productId}`, 'gaEvent');
            break;
          }
          case 'error': {
            if (reason === 'cart-max-count-exceeded') {
              cartMaxCountExceededPopup();
              App.global.sendErrorLog('Home Trial - cart max count exceeded');
            }
            break;
          }
          default: {
            break;
          }
        }
      } catch (err) {
        App.sendErrorToRaygun(err);
      }
    };

    const removeProductFromHomeTrialCart = async (e, { hash }) => {
      try {
        await $.ajax({
          url: '/home-trial/remove',
          data: { hash },
          type: 'POST',
        });
      } catch (err) {
        App.sendErrorToRaygun(err);
        errorPopup();
      } finally {
        App.eventBus.trigger('quickcart:open');
      }
    };

    const confirmPopup = (whenOK, productName = '') => {
      App.ui.popup(texts('confirmRemove@cart').replace('\'@\'', productName), {
        className: 'dialog-window',
        confirm: {
          ok: {
            text: texts('delete@'),
            callback: whenOK,
          },
          cancel: {
            text: texts('cancelText@misc'),
          },
        },
      });
    };

    const lessThanFourProductsPopup = (whenOK, whenCancel) => {
      App.ui.popup(texts('homeTrialQuickCartLessThan4PopupText@homeTrial'), {
        className: 'dialog-window home-trial__popup',
        confirm: {
          ok: {
            text: texts('homeTrialQuickCartLessThan4PopupGoToCart@homeTrial'),
            callback: whenOK,
          },
          cancel: {
            text: texts('homeTrialQuickCartLessThan4PopupFindMore@homeTrial'),
            callback: whenCancel,
          },
        },
      });
    };

    const renderQuickCart = (e, homeTrialCartItems) => {
      const emptyItems = 4 - (homeTrialCartItems.length || 0);
      let content;
      const isDifferentSizesAdded = isDifferentHomeTrialSizesAdded(homeTrialCartItems);

      if (homeTrialCartItems.length > 0) {
        content = JST['quick-cart-home-trial-rows']({
          homeTrialCartItems,
          isDifferentSizesAdded,
        });

        for (let i = 0; i < emptyItems; i += 1) {
          content += JST['quick-cart-home-trial-empty-row'](homeTrialCartItems);
        }
        $homeTrialQuickCartEmptyCTA.hide();
        $homeTrialQuickCartCTA.show();
      } else {
        $homeTrialQuickCartEmptyCTA.show();
        $homeTrialQuickCartCTA.hide();
        content = JST['quick-cart-home-trial-empty-cart']();
      }
      $homeTrialQuickCartCTA.attr('data-home-trial-items-in-cart-count', homeTrialCartItems.length);
      $('#homeTrialQuickCartContent').html(content);
    };

    const renderCart = (homeTrialCartItems) => {
      const emptyHomeTrialCart = !homeTrialCartItems || homeTrialCartItems.length <= 0;

      if (emptyHomeTrialCart) {
        $('#homeTrialCartContent')
          .html(JST['cart-home-trial-empty-cart']());
      } else {
        let content = JST['quick-cart-home-trial-rows']({ homeTrialCartItems });
        $('#homeTrialCartContent')
          .html(content);
      }
      $homeTrialPlaceOrderButton.toggleClass('inactive', emptyHomeTrialCart);
      $homeTrialCartWrapper.attr('data-full-home-trial-cart', () => homeTrialCartItems && homeTrialCartItems.length >= 4);
      $homeTrialCartWrapper.attr('data-empty-home-trial-cart', () => emptyHomeTrialCart);
    };

    const handleCartTracking = (homeTrialCartItems) => {
      const productIDs = homeTrialCartItems.reduce((accumulator, currentValue) => (
        `${accumulator},${currentValue.productItem.productID}`
      ), '').replace(',', '');
      if (productIDs && productIDs.length > 0) {
        TrackApp.trackInteraction('home trial', 'check out', productIDs, 'gaEvent');

        homeTrialCartItems.forEach((item) => {
          const { homeTrialIsInStock, homeTrialEnabled, productID } = item.productItem;
          if (!homeTrialIsInStock && homeTrialEnabled) {
            App.global.sendErrorLog(`Home trial frame out of stock ${productID}`);
          } else if (!homeTrialEnabled) {
            App.global.sendErrorLog(`Home trial frame unavailable ${productID}`);
          }
        });
      }
    };

    const removeErrorMessage = () => $homeTrialFormErrorMessage.hide().html('');

    const updateCart = async () => {
      const { homeTrialCartItems } = await getHomeTrialProducts();
      renderCart(homeTrialCartItems);
      handleCartTracking(homeTrialCartItems);
      removeErrorMessage();
    };

    const handleHomeTrialCTAClick = (e) => {
      const { trackCtaClickMobile } = App?.productPage || {};
      if (typeof trackCtaClickMobile === 'function') {
        trackCtaClickMobile({
          cta: 'ht cta',
          isStickyCta: e.currentTarget.hasAttribute('data-sticky-cta'),
        });
      }
      if ($('[data-home-trial]').attr('data-home-trial-stock') === 'in-stock') {
        const $target = $(e.currentTarget);
        const productId = $target.attr('data-id');
        App.eventBus.trigger('home-trial:add', { productId });
      }
    };

    const removeHomeTrialProduct = async (e) => {
      const $target = $(e.currentTarget);
      const hash = $target.attr('data-rowhash');
      const productName = $target.attr('data-product-name');

      confirmPopup(async () => {
        await removeProductFromHomeTrialCart(null, { hash });
        if (isSessionStorageSupported()) {
          window.sessionStorage.removeItem('homeTrialPackAdded');
        }
        App.eventBus.trigger('quickcart:update');
        App.eventBus.trigger('home-trial:update-cart');
      }, productName);
    };

    const linkToHomeTrialListPage = () => {
      const anchor = App.global.isMobile() ? '#list-page-status-section' : '';
      window.location.href = `${texts('homeTrialListPageURL@homeTrial')}${anchor}`;
    };

    const linkToHomeTrialCartPage = (e) => {
      e.preventDefault();
      if ($(e.currentTarget).attr('data-home-trial-items-in-cart-count') === '4') {
        window.location.href = '/home-trial/cart';
        return;
      }
      lessThanFourProductsPopup(() => {
        window.location.href = '/home-trial/cart';
      }, linkToHomeTrialListPage);
    };

    const handleSubmitError = ({ reason, invalidOrderRows }) => {
      switch (reason) {
        case 'validation-error': {
          handleSubmitError(reason);
          $homeTrialFormErrorMessage.show()
            .html(texts('cartUserValidationErrorMessage@homeTrial'));
          break;
        }
        case 'ongoing-home-trial': {
          $homeTrialFormErrorMessage.show()
            .html(texts('cartUserHasExistingHomeTrialOrderErrorMessage@homeTrial'));
          break;
        }
        case 'no-shipping-options-for-zip': {
          $homeTrialFormErrorMessage.show().html(texts('noUnifaunShippingOptionForZipErrorMessage@homeTrial'));
          break;
        }
        case 'product-out-of-stock-or-invalid': {
          $homeTrialFormErrorMessage.show()
            .html(texts('cartSomeProductsOutOfStockErrorMessage@homeTrial'));
          if (invalidOrderRows) {
            const invalidIds = invalidOrderRows.split(',');
            invalidIds.forEach((invalidId) => {
              $(`#homeTrialCartContent [data-id="${invalidId}"]`)
                .attr('data-stock-status', 'out-of-stock');
            });
          }
          break;
        }
        default: {
          $homeTrialFormErrorMessage.show()
            .html('General error');
          break;
        }
      }
    };

    const homeTrialFormSubmitHandler = async (form, event) => {
      event.preventDefault();
      if ($homeTrialPlaceOrderButton.attr('data-loading') !== undefined) {
        return;
      }
      const url = $homeTrialForm.attr('action');
      const data = $homeTrialForm.serialize();
      $homeTrialPlaceOrderButton.attr('data-loading', '');
      try {
        const res = await $.ajax({
          type: 'POST',
          url,
          data,
        });

        switch (res.status) {
          case 'ok': {
            window.location.href = '/home-trial/success';
            return;
          }
          case 'error': {
            handleSubmitError(res);
            break;
          }
          default:
            break;
        }
      } catch (err) {
        $homeTrialFormErrorMessage.show()
          .html('General error');
        App.sendErrorToRaygun(err);
      }
      $homeTrialPlaceOrderButton.removeAttr('data-loading');
    };

    const registerProductView = () => {
      if ($('[data-home-trial]').length && $('[data-home-trial-enabled]').attr('data-home-trial-enabled') === 'true') {
        App.eventBus.trigger('home-trial:product-view', {
          id: $('[data-home-trial]').attr('data-id'),
          outOfStock: $('[data-home-trial-stock]').attr('data-home-trial-stock') === 'out-of-stock',
        });
      }
    };

    const handleProductView = (a, data) => {
      const { id, outOfStock } = data;
      TrackApp.trackInteraction(
        'home trial',
        outOfStock ? 'product page out of stock' : 'product page in stock',
        id,
        'gaEventNonInteraction',
      );
    };

    const handleProductPageUpdate = (e, data = {}) => {
      const {
        homeTrialEnabled, homeTrialIsInStock, itemID, type, changeType,
      } = data;
      if (type !== 'FRAME') return;
      $('[data-home-trial]').attr({
        'data-home-trial-stock': homeTrialIsInStock === true ? 'in-stock' : 'out-of-stock',
        'data-id': itemID,
        class: () => {
          if (homeTrialIsInStock === true) {
            return 'btn-cta-secondary full-width';
          }
          return 'btn-cta-secondary full-width inactive two-rows';
        },
      });
      $('[data-home-trial]')
        .parent('.product-page__ctas-row')
        .attr('data-home-trial-enabled', homeTrialEnabled);

      if (changeType) {
        let stockStatus = 'not enabled';
        if (homeTrialEnabled) {
          stockStatus = homeTrialIsInStock ? 'in stock' : 'out of stock';
        }
        const eventAction = `product page ${stockStatus} - ${changeType}`;

        TrackApp.trackInteraction(
          'home trial',
          eventAction,
          itemID,
          'gaEventNonInteraction',
        );
      }
    };

    const validateFormState = (e) => {
      if ($(e.currentTarget).hasClass('inactive')) {
        e.preventDefault();
      }
    };

    const initializeFormValidator = () => {
      let phone;
      if (App.settings.lang === 'no') {
        phone = 'phoneNO';
      } else if (App.settings.lang === 'fi') {
        phone = 'phoneFI';
      } else if (App.settings.lang === 'da') {
        phone = 'phoneDA';
      } else {
        phone = 'phoneSE';
      }

      $homeTrialForm.validate({
        submitHandler: homeTrialFormSubmitHandler,
        ignore: '[data-secure-personal-number]',
        rules: {
          phone,
          firstName: 'minTwoCharacters',
          lastName: 'minTwoCharacters',
          street: 'minTwoCharacters',
          city: 'minTwoCharacters',
          email: 'rfc2822Email',
        },
      });
    };

    const initEventListeners = () => {
      App.eventBus.on('home-trial:add', addProductToHomeTrialCart);
      App.eventBus.on('home-trial:add-pack', addHomeTrialPackToCart);
      App.eventBus.on('home-trial:remove', removeProductFromHomeTrialCart);
      App.eventBus.on('home-trial:render-quickcart', renderQuickCart);
      App.eventBus.on('home-trial:update-cart', updateCart);
      App.eventBus.on('home-trial:product-view', handleProductView);
      App.eventBus.on('product-page:update', handleProductPageUpdate);

      $('[data-home-trial]').on('click', handleHomeTrialCTAClick);
      $quickcartWrapper
        .on('click', '[data-remove-home-trial]', removeHomeTrialProduct)
        .on('click', '[data-home-trial-link]', linkToHomeTrialListPage);

      $homeTrialCartWrapper
        .on('click', '[data-remove-home-trial]', removeHomeTrialProduct)
        .on('click', '[data-home-trial-link]', linkToHomeTrialListPage);

      $homeTrialQuickCartCTA.on('click', linkToHomeTrialCartPage);
      $homeTrialFormInputs.change(removeErrorMessage);
      $homeTrialPlaceOrderButton.on('click', validateFormState);
    };

    const isEnabled = () => !!App.settings.homeTrialEnabled;

    const init = () => {
      $quickcartWrapper = $('[data-quick-cart]');
      $homeTrialCartWrapper = $('[data-appmodule="cartHomeTrial"]');
      $homeTrialForm = $('#homeTrialCartForm');
      $homeTrialFormInputs = $('input', $homeTrialForm);
      $homeTrialQuickCartCTA = $('[data-home-trial-not-empty-cart-cta]');
      $homeTrialQuickCartEmptyCTA = $('[data-home-trial-empty-cart-cta]');
      $homeTrialPlaceOrderButton = $('[data-place-home-trial-order]');
      $homeTrialFormErrorMessage = $('[data-form-error]');
      initEventListeners();
      if (App.currentPage === 'cartHomeTrial') {
        initializeFormValidator();
      }
      registerProductView();
    };

    return {
      init,
      isEnabled,
    };
  })();
})();
